import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import useStructureSet from '~/hooks/structure-set/useStructureSet';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import EmptyStructureSet from './EmptyStructureSet';
import StructureSet from './StructureSet';
import StructureSetHeader from './StructureSetHeader';
import StructureSetTitle from './StructureSetTitle';

export default function Structures() {
    const [isExpanded, setIsExpanded] = useState(true);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const { structureSet, deleteRoi } = useStructureSet(currentStructureSet);

    return (
        selectedPatientId && (
            <>
                <Divider />
                <Box
                    height="100%"
                    position="relative"
                    px={2}
                    display="grid"
                    gridTemplateRows="auto 1fr"
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            onClick={() => setIsExpanded(!isExpanded)}
                            sx={(theme) => ({
                                cursor: 'pointer',
                                color: theme.palette.primary.main,
                            })}
                        >
                            <Box display="flex" alignItems="center">
                                {isExpanded ? (
                                    <ChevronDown size={14} />
                                ) : (
                                    <ChevronUp size={14} />
                                )}
                            </Box>
                            <StructureSetTitle />
                        </Box>
                        <StructureSetHeader />
                    </Box>
                    {isExpanded &&
                        (structureSet ? (
                            <StructureSet
                                structureSet={structureSet}
                                deleteRoi={deleteRoi}
                            />
                        ) : (
                            <EmptyStructureSet />
                        ))}
                </Box>
            </>
        )
    );
}
